import { OfferData } from '../../core/domain/offerData.model'

const calculatorRoutes = [
  'vehicles',
  'deductible',
  'location-scope',
  'transporting-goods',
  'previous-insurance',
  'contact-data',
]

export const redirectionProvider = {
  redirectToFollowingStep: (currentStep: string, offer: OfferData) => {
    if (offer.progressMask.substr(0, 6) === '111111') return '/summary'
    const currentStepIndex = calculatorRoutes.findIndex(
      (value, index) => value === currentStep,
    )
    if (currentStepIndex + 1 === calculatorRoutes.length) {
      const firstUnfinished = offer.progressMask.indexOf('0')
      return `/calculator/${calculatorRoutes[firstUnfinished]}`
    }
    if (currentStepIndex < 0) return '/'
    return `/calculator/${calculatorRoutes[currentStepIndex + 1]}`
  },

  redirectToPreviousStep: (currentStep: string, offer: OfferData) => {
    if (offer.progressMask[6] === '1') return '/summary'
    const currentStepIndex = calculatorRoutes.findIndex(
      (value, index) => value === currentStep,
    )
    const previousStepIndex =
      currentStep === 'vehicles' ? 0 : currentStepIndex - 1
    return `/calculator/${calculatorRoutes[previousStepIndex]}`
  },

  redirectToStep: (step: number) => {
    if (step > calculatorRoutes.length || step <= 0) {
      return ''
    }
    return `/calculator/${calculatorRoutes[step - 1]}`
  },
}
